export const SECTION_TYPES = {
  SECTIONS: 'sections',
  TIERS: 'tiers',
  DEFAULT: 'default'
} as const;

export const DROPPABLE_IDS = {
  SECTIONS: 'sections',
  DEFAULT: 'default'
} as const;

export const TOAST_MESSAGES = {
  SECTION_UPDATE_ERROR: 'Error updating section',
  SECTION_DELETE_ERROR: 'Error deleting section'
} as const; 